module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "con-main",
    class: {
      change: _vm.ok, zz: _vm.open
    }
  }, [_c('router-view', {
    staticClass: "view",
    attrs: {
      "id": "view"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3355933f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Appmain.vue
// module id = 1047
// module chunks = 2